var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.distinguish == 1 ? 'cola-list1' : 'cola-list'},[_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"cola-list-i"},[_c('div',{staticClass:"cola-list-img"},[_c('img',{attrs:{"src":_vm.nubre == i ? _vm.list1[i] : _vm.nubre == 8 ? _vm.list1[i] : item.imgag,"alt":""}})]),_c('div',{staticClass:"cola-list-acvie"},[_c('div',{staticClass:"cola-list-acvie-g"}),_c('div',{staticClass:"cola-list-acvie-name",style:({
          backgroundImage:
            _vm.nubre == i
              ? ("url(" + _vm.imgag + ")")
              : _vm.nubre == 8
                ? ("url(" + _vm.imgag + ")")
                : ("url(" + _vm.imgag1 + ")"),
        }),on:{"click":function($event){return _vm.avice(i)}}},[_vm._v(_vm._s(item.name))])])])}),_c('div',{staticClass:"backimg"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }